module.exports = __webpack_public_path__ + "static/media/toast-info.b821549e.svg";